export type ProcedureSuggestionLike = {
	CreatedBy?: { Id?: number | null } | null;
	Status?: string | null;
};

type ProcedureChecklistLike = {
	ProcedureUpdateSuggestions?: ProcedureSuggestionLike[] | null;
};

type ProcedureSuggestionGroupLike = {
	Checklists?: ProcedureChecklistLike[] | null;
};

export type ImprovementsSubTab =
	| "newImprov"
	| "myImprov"
	| "verified"
	| "declined"
	| "closed";

export function matchesImprovementSubTab(
	suggestion: ProcedureSuggestionLike,
	subTab: ImprovementsSubTab,
	userId: number,
): boolean {
	switch (subTab) {
		case "newImprov":
			return (suggestion.Status ?? "") === "Unverified";
		case "myImprov":
			return userId > 0 && (suggestion.CreatedBy?.Id ?? 0) === userId;
		case "verified":
			return (suggestion.Status ?? "") === "Verified";
		case "declined":
			return (suggestion.Status ?? "") === "Declined";
		case "closed":
			return (suggestion.Status ?? "") === "Closed";
		default:
			return false;
	}
}

export function countSuggestionsMatching(
	procedures: unknown,
	match: (suggestion: ProcedureSuggestionLike) => boolean,
): number {
	if (!Array.isArray(procedures)) return 0;

	let count = 0;
	(procedures as ProcedureSuggestionGroupLike[]).forEach((procedure) => {
		procedure.Checklists?.forEach((checklist) => {
			checklist.ProcedureUpdateSuggestions?.forEach((suggestion) => {
				if (match(suggestion)) {
					count++;
				}
			});
		});
	});

	return count;
}

export function countSuggestionsByStatus(
	procedures: unknown,
	status: string,
	userId: number | null = null,
): number {
	return countSuggestionsMatching(
		procedures,
		(suggestion) =>
			(userId === null || suggestion.CreatedBy?.Id === userId) &&
			suggestion.Status === status,
	);
}

export function countSuggestionsByUser(
	procedures: unknown,
	userId: number,
): number {
	if (!userId) return 0;

	return countSuggestionsMatching(
		procedures,
		(suggestion) =>
			suggestion.CreatedBy?.Id === userId &&
			(suggestion.Status ?? "") !== "Closed",
	);
}

export function countImprovementsBadge(
	procedures: unknown,
	isProcedureSuggestionsAdministrator: boolean,
	userId?: number,
): number {
	return isProcedureSuggestionsAdministrator
		? countSuggestionsByStatus(procedures, "Unverified")
		: countSuggestionsByUser(procedures, userId ?? 0);
}
